import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact';
import {
  productImagePlaceholder,
  getUrlLastPath,
  getCustomFieldText,
} from '../helpers';
import { useState, useMemo, useEffect } from 'preact/hooks';
import { Review } from './elements';

export default function ProductNoGql({ product }) {
  const { format } = useCurrencyFormatting();

  const [productVariants, setProductVariants] = useState([]);

  const hasLabel = (array, label) => array?.includes(label);

 // const bestSellerLabel = '_label_Best Seller 🔥';
  //const twlAwardsWinnerLabel = '_label_🏆 TWL Awards Winner';
  const comingSoonTag = 'coming-soon';
  const hideQuickAddTag = 'hide-quick-add';
  const preOrderTag = 'pre-order';
  const OutOfStockTag = 'out-of-stock';
  const ignoreTag = 'nosto-ignore';
  const twlBerry = 'twl-berry';
  //const refineProduct = 'refine-range';
  //const maverickProduct = 'maverick_momentum';
  //const maverickCoreProduct = 'maverick_core';
  const cadenceShort = 'content:cadence-shorts';

  // console.log(product.customFields);

  const isOnSale = useMemo(
    () => product.listPrice && product.listPrice > product.price,
    [product.listPrice, product.price]
  );

  const isSoldOutItem = useMemo(() => !product.available, [product.available]);

  const hideQuickAdd = useMemo(() => {
    const result = hasLabel(product.tags1, hideQuickAddTag);
 
    return result ? 'hide' : '';
  }, [product.tags1]);

  const isTWLBerry = useMemo(() => {
    const result = hasLabel(product.tags1, twlBerry);
 
    return result ? 'product__berry' : '';
  }, [product.tags1]);

  const isPreOrder = useMemo(() => {
    const result = hasLabel(product.tags1, preOrderTag);
    if (result) {
      console.log('Preorder label has been added');
    }
    return result;
  }, [product.tags1]);

  const isComingSoon = useMemo(() => {
    const result = hasLabel(product.tags1, comingSoonTag);

    return result;
  }, [product.tags1]);

  const hasOutOfStockTag = useMemo(() => {
    const result = hasLabel(product.tags1, OutOfStockTag);

    return result;
  }, [product.tags1]);

  const ignoreProduct = useMemo(() => {
    const result = hasLabel(product.tags1, ignoreTag);
 
    return result ? 'hide' : '';
  }, [product.tags1]);

  const rangeProduct = useMemo(() => {
    const hasRefine = hasLabel(product.tags1, cadenceShort);
    //const hasMaverickMomentum = hasLabel(product.tags1, maverickProduct);
    //const hasMaverickCore = hasLabel(product.tags1, maverickCoreProduct);
  
    return hasRefine ? 'range-sale' : '';
  }, [product.tags1]);

  /*const bestSeller = useMemo(() => {
    const result = hasLabel(product.tags1, bestSellerLabel);
    if (result) {
      console.log('Best Seller label has been added');
    }
    return result;
  }, [product.tags1]);

  const twlAwardsWinner = useMemo(() => {
    const result = hasLabel(product.tags1, twlAwardsWinnerLabel);
    if (result) {
      console.log('TWL Awards Winner label has been added');
    }
    return result;
  }, [product.tags1]);*/

  const labelTag = useMemo(() => {
    const label = product.tags1.find(tag => tag.startsWith('_label_'));
    
    return label ? label.replace('_label_', '') : null;
  }, [product.tags1]);

  const productHandle = useMemo(() => {
    return getUrlLastPath(product.url);
  }, [product.url]);

  const productQuery = useMemo(() => {
    const lastDashIndex = product.name.lastIndexOf(' - ');
    if (lastDashIndex !== -1) {
      return product.name.substring(0, lastDashIndex);
    }
    return product.name;
  }, [product.name]);

  const handleize = (str) =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');


   //console.log(productVariants, 'productVariants 💜');
  const currencySymbol = '$';
  const saveDiscount = product.listPrice - product.price;
  const hasSizeSkus = useMemo(() => {
    const sizeSkus = product.skus.filter((sku) =>
      sku.customFields.some((field) => field.key.toLowerCase() === 'size')
    );
    return sizeSkus.length > 0 ? sizeSkus.length : false;
  }, [product.skus]);


  const handleAddToCart = () => {
    if (hasSizeSkus > 1) return null;
    let prodId = product.productId;
    let skuId = product.skus[0].id;

    Nosto.addSkuToCart(
      { productId: prodId, skuId: skuId },
      '$!products[0].attributionKey'
    )
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
  };

  useEffect(() => {
    let body = `
            query {
              products(
                limit: 20
                filter: {search: "${productQuery}"}
                ) {
                products {
                  name
                  availability
                  brand
                  productId
                  imageUrl
                  price
                  listPrice
                  url
                  tags1
                  tags2
                  tags3
                  skus {
                    id
                    name
                    imageUrl
                    inventoryLevel
                    availability
                    price
                    attributes {
                        key
                        value
                      }
                  }
                }
              }
            }
            `;

    fetch('https://api.nosto.com/v1/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        Authorization:
          'Basic ' +
          btoa(
            ':' +
              'RR4mEcWmRDaQeoYpP0tnjEnikNBe0LPgHXbQNyQ6pDQkPvjnqzQ64jqbsIlZ69ZF'
          ),
      },
      body: body,
    })
      .then((response) => response.json())
      .then((r) => {
        // Handle the response or remove the variable if not needed
        let products = r.data?.products?.products;

        products?.forEach((product) => {
          product.price = currencySymbol + product.price.toFixed(2);
          product.listPrice = currencySymbol + product.listPrice.toFixed(2);

          product.skus.forEach((sku) => {
            sku.price = currencySymbol + sku.price.toFixed(2);
          });
        });
        // console.log(products, 'products 🟪');

        products?.filter((product) => {
          let areAllSkusOutOfStock = product.skus.every(
            (sku) => sku.availability === 'OutOfStock'
          );
          if (!areAllSkusOutOfStock) {
            setProductVariants((prev) => [...prev, product]);
          }
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    // Get the right tag for the product-variant
  }, [product]);

  return (
    <SerpElement
      as="article"
      hit={product}
      className={`gc_grid_item ${isSoldOutItem ? 'sold-out-item' : ''} ${ignoreProduct} ${rangeProduct} ${isTWLBerry}`}
    >
      <div
        class="grid__item grid-product grid-product__has-quick-shop ="
        data-product-handle={productHandle}
        data-product-id={product.productId}
        data-product-query={productQuery}
        data-current-product={productHandle}
        data-product-name={product.name}
        data-product-price={product.price}
        data-item-query="product-query"
      >
        <div
          class={`grid-product__content has-quick-add ${
            productVariants.length > 1 && 'has-colours'
          }`}
        >

        {labelTag ? (
          <div className={`grid-product__tag grid-product__tag--custom grid-product__tag--custom-${handleize(labelTag)}`}>
            {labelTag}
          </div>
        ) : isPreOrder ? (
          <div className="grid-product__tag grid-product__tag--custom">
            Pre-Order
          </div>
        ) : isOnSale ? (
          <div className="grid-product__tag grid-product__tag--sale">
            Sale
          </div>
        ) : null}

          <div class="grid__item-image-wrapper">
            <div class="grid-product__image-mask">
              <div class="grid-product__tag grid-product__tag--more-colours">
                More Colours
              </div>

              <div
                class="grid-product__quick-add-wrapper"
                style="display: block"
              >
                {/* 🟪 <!-- Quick Add 🟪 --> */}
                <div className={`grid-product__quick-add ${hideQuickAdd}`}>
                  <button
                    onClick={handleAddToCart}
                    type="button"
                    class="grid-product__quick-add-btn h5 text-heading add"
                    data-id={product.skus[0].id}
                    skuId={product.skus[0].id}
                    prodId={product.productId}
                    skusCheck={hasSizeSkus}
                  >
                    <span>Quick Add </span>+
                  </button>
                  {hasSizeSkus > 1 && (
                    <div class="grid-product__quick-add-panel">
                      {product.skus.map((sku) => {
                        let isOutOfStock = sku.availability === 'OutOfStock';

                        return (
                          <button
                            class="grid-product__quick-add-var"
                            data-id={sku.id}
                            disabled={isOutOfStock}
                          >
                            {sku.customFields.find(
                              (attr) => attr.key.toLowerCase() === 'size'
                            )?.value || 'N/A'}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              <a
                class="grid-product__link"
                href={product.url}
                aria-label={product.name}
                data-product={productHandle}
              >

                {/*{isSoldOutItem && (hasOutOfStockTag || isComingSoon) && (
                  <div className="grid-product_notify-me">
                    <a
                      href="#"
                      className="SI_trigger"
                      data-product-data={JSON.stringify(productData)}
                    >
                        {(isComingSoon || !hasOutOfStockTag) ? 'Coming Soon' : 'Out Of Stock'} - Notify me
                    </a>
                  </div>
                )}*/}
                
                {isSoldOutItem && (hasOutOfStockTag || isComingSoon) && (
                <div className="klaviyo-product-container grid-product_notify-me" data-variant-id={product.skus[0].id} data-product-title={product.name} data-product-id={product.productId} id={`klaviyo-data-handle-${ productHandle }`} data-klaviyo-handle={productHandle}>
                  <div className="klaviyo-button-container">
                    <a className="btn--bis-col klaviyo-bis-trigger" data-variant-id={product.skus[0].id} data-product-title={product.name} data-product-id={product.productId} data-klaviyo-handle={productHandle} href={product.url}>{(isComingSoon || !hasOutOfStockTag) ? 'Coming Soon' : 'Out Of Stock'} - Notify me</a>
                  </div>
                </div>
                )}
                  <div class="gc_product_item_image-wrapper image-wrap">
                    <svg
                      class="gc_product_item_placeholder"
                      version="1.0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="525.000000pt"
                      height="525.000000pt"
                      viewBox="0 0 525.000000 525.000000"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <g
                        transform="translate(0.000000,525.000000) scale(0.100000,-0.100000)"
                        fill="#000000"
                        stroke="none"
                      >
                        <path d="M220 3068 l0 -153 150 150 c83 82 150 151 150 152 0 2 -67 3 -150 3 l-150 0 0 -152z"></path>
                        <path d="M1255 3070 c82 -82 151 -150 152 -150 2 0 3 68 3 150 l0 150 -152 0 -153 0 150 -150z"></path>
                        <path d="M1786 3076 c-26 -79 -46 -149 -46 -155 0 -8 52 -11 170 -11 94 0 170 -2 170 -4 0 -2 -61 -198 -135 -436 -74 -238 -135 -437 -135 -442 0 -5 77 -7 172 -6 l172 3 137 440 136 440 90 3 90 3 6 -167 c4 -92 7 -235 7 -318 0 -83 3 -208 7 -279 l6 -127 156 2 155 3 206 313 205 312 6 -51 c4 -28 10 -169 14 -315 l8 -264 160 2 160 3 303 474 c167 261 304 471 304 467 0 -6 -229 -750 -286 -928 -5 -17 21 -18 449 -18 l454 0 53 153 c29 83 55 158 57 165 4 9 -55 12 -276 12 -155 0 -281 1 -281 3 0 1 58 196 129 432 l129 430 -322 3 c-297 2 -322 1 -334 -15 -7 -10 -97 -156 -200 -326 l-187 -307 -7 82 c-3 46 -6 171 -7 279 -1 108 -4 217 -7 243 l-7 46 -146 0 -146 0 -205 -322 -205 -322 -3 322 -2 322 -565 0 -564 0 -45 -144z"></path>
                        <path d="M547 2893 l-57 -58 107 -107 108 -108 -108 -108 -107 -107 57 -58 58 -57 107 107 108 108 105 -105 105 -105 57 57 57 57 -104 106 -104 105 104 105 104 106 -57 57 -57 57 -105 -105 -105 -105 -108 108 -107 107 -58 -57z"></path>
                        <path d="M220 2170 l0 -150 152 0 153 0 -150 150 c-82 83 -151 150 -152 150 -2 0 -3 -67 -3 -150z"></path>
                        <path d="M1255 2170 l-150 -150 153 0 152 0 0 150 c0 83 -1 150 -3 150 -1 0 -70 -67 -152 -150z"></path>
                      </g>
                    </svg>
                    <img
                      loading="lazy"
                      className="gc_product_item_image grid-product__image image-element"
                      src={product.imageUrl ?? productImagePlaceholder}
                      srcSet={`${product.imageUrl.replace(
                        '.jpg',
                        '_300x.jpg'
                      )} 300w, ${product.imageUrl.replace(
                        '.jpg',
                        '_600x.jpg'
                      )} 600w, ${product.imageUrl.replace(
                        '.jpg',
                        '_900x.jpg'
                      )} 900w, ${product.imageUrl.replace(
                        '.jpg',
                        '_900x.jpg'
                      )} 1080w`}
                      sizes="(max-width: 900px) 300px, (min-width: 900px) 600px, 900px"
                      alt={product.name}
                      width="300"
                      height="300"
                    />
                  </div>
                  <div
                  className="grid-product__secondary-image small--hide"
                  style={{
                    backgroundImage: `url(${product.alternateImageUrls?.[0]?.replace('.jpg', '_900x.jpg')})`,
                    backgroundSize: 'cover',
                  }}
                ></div>

                
              </a>
            </div>

            <div class="grid-product__meta-wrapper">
              <a
                href={product.url}
                class="grid-product__link"
                aria-label={product.name}
              >
                <div
                  style="display:none;"
                  class="discount-message__wrapper"
                ></div>
                <div class="grid-product__meta">
                  <div class="h5 text-bold grid-product__title grid-product__title--body">
                    {product.name}
                  </div>

                  <div class="gc_p_review">
                    <div
                      class="jdgm-widget jdgm-preview-badge"
                      data-id={product.productId}
                    >
                      
                      <Review
                        score={getCustomFieldText(
                          product.customFields,
                          'reviews-rating'
                        )}
                        count={getCustomFieldText(
                          product.customFields,
                          'judgeme-badge'
                        )}
                        />

                    </div>
                  </div>
                  {product.brand && (
                    <div class="grid-product__vendor">{product.brand}</div>
                  )}

                  {/* Price */}
                  <div class="grid-product__price">
                    {product.listPrice && product.listPrice > product.price && (
                      <>
                        <span class="text-bold text-red ns-pr-1">
                          <span class="money nsc_money">
                            {currencySymbol + product.price.toFixed(2)}
                          </span>
                        </span>
                        <span class="grid-product__price--original ns-text-striked">
                          <span class="money nsc_money">
                            <span class="money nsc_money">
                              {currencySymbol + product.listPrice.toFixed(2)}
                            </span>
                          </span>
                        </span>
                      </>
                    )}
                    {product.listPrice &&
                      product.listPrice === product.price && (
                        <span class="money nsc_money">
                          <span class="money nsc_money">
                            {currencySymbol + product.price.toFixed(2)}
                          </span>
                        </span>
                      )}
                    {product.listPrice && product.listPrice > product.price && (
                      <span class="grid-product__price--savings">
                        {`Save ${currencySymbol + saveDiscount.toFixed(2)}`}
                      </span>
                    )}
                  </div>
                  {/* Price end  */}
                </div>
              </a>
              {/* SWATCHES VARIANTS */}
              {productVariants.length > 1 && (
                <div
                  class="nosto-search-color-swatches-wrapper aa-wrapper aa-wrapper--colour-swatch"
                  style=""
                  data-section-type="product-color-swatch--full"
                  data-request-query={productQuery}
                  data-current-product={productHandle}
                  data-product-name={product.name}
                  data-image-url-structure="//www.thewodlife.com.au/cdn/shop/files/colour----productTitle---.png"
                >
                  <div class="aa-container aa-container--colour-swatch nosto-search-color-swatches">
                    {productVariants.slice(0, 5).map((variant) => {
                      let dataUrl = `/products/${variant.url.split('/').pop()}`;
                      let skuHandle = variant.url.split('/').pop();
                      let altImg = variant.skus[0].imageUrl;
                      let skuDiscounted = variant.listPrice !== variant.price;
                      let skuSizes = [];
                      let skuSizesString = '';

                      //console.log(variant);

                      //console.log(skuDiscounted, 'skuDiscounted 🟪');

                      variant.skus?.forEach((sku) => {
                        let skuSize = sku?.attributes?.find(
                          (attr) => attr.key.toLowerCase() === 'size'
                        );
                        let skuAvailability =
                          sku.availability === 'OutOfStock' ? 'disabled' : '';

                        if (skuSize) {
                          skuSizes.push(
                            `
                          <button class="grid-product__quick-add-var" data-id="${sku.id}" ${skuAvailability}>
                            ${skuSize.value}
                          </button>
                          `
                          );
                          skuSizesString = skuSizes.join('');
                        }
                      });

                      return (
                        <span
                          class="nosto-swatch product-swatch-button product-swatch-button--colour-swatch aa-swatch--current aa-swatch--initial"
                          data-image={variant.imageUrl}
                          data-second-image={variant.imageUrl} /* Need to work for secondary image as {altImg} is null */
                          data-url={dataUrl}
                          data-product={skuHandle}
                          data-title={variant.name}
                          data-id={variant.productId}
                          data-first-var-id={variant.skus[0].id}
                          data-price={variant.price}
                          data-price-raw={variant.price}
                          data-compare-at-price={variant.listPrice}
                          data-compare-at-price-raw={variant.listPrice}
                          data-sizes={skuSizesString}
                          data-label-tags="[]"
                          data-discount-message=""
                          data-icon-label=""
                          title={variant.name}
                          style={{
                            backgroundImage: `url(${variant.imageUrl})`,
                          }}
                        ></span>
                      );
                    })}
                  </div>
                </div>
              )}
              
            </div>
          </div>
        </div>
      </div>
    </SerpElement>
  );
}
